import React from 'react';

import { useSidebarInfo } from '@/Product/hooks/useSidebarInfo';

import ArtistDropdown from './ArtistDropdown';
import CategoryDropdown from './CategoryDropdown';
import KeywordGroupDropdown from './KeywordGroupDropdown';
import TagDropdown from './TagDropdown';
import VendorDropdown from './VendorDropdown';

const ProductSidebar: React.FC = () => {
  const {
    sidebarInfo,
    handleCategoryChange,
    handleArtistChange,
    handleArtistRemove,
    handleVendorChange,
    handleTagChange,
    handleTagRemove,
    handleKeywordGroupChange,
    handleKeywordGroupRemove,
    handleReleaseDateChange,
    handleSalesStartDateChange,
    handleSalesEndDateChange,
    formatDateForInput,
  } = useSidebarInfo();

  return (
    <div className="flex w-[32%] flex-col gap-5">
      {/* Product Category and Details */}
      <div className="flex flex-col gap-5 rounded border border-[#F1F1F1] bg-white p-5 shadow-sm">
        {/* Product Category */}
        <div>
          <h2 className="text-base font-medium">Product category</h2>
          <div className="mt-3">
            <CategoryDropdown
              selectedCategory={sidebarInfo.category}
              onCategoryChange={handleCategoryChange}
            />
          </div>
        </div>

        {/* Artists */}
        <div>
          <h2 className="text-base font-medium">Artists</h2>
          <div className="mt-3">
            <ArtistDropdown
              selectedArtists={sidebarInfo.artistList}
              onArtistChange={handleArtistChange}
              onArtistRemove={handleArtistRemove}
            />
          </div>
        </div>

        {/* Vendor */}
        <div>
          <h2 className="text-base font-medium">Vendor</h2>
          <div className="mt-3">
            <VendorDropdown
              currentVendor={
                sidebarInfo.vendor.id
                  ? {
                      id: sidebarInfo.vendor.id,
                      vendor: sidebarInfo.vendor.vendor,
                    }
                  : null
              }
              onVendorChange={handleVendorChange}
            />
          </div>
        </div>

        {/* Tags */}
        <div>
          <h2 className="text-base font-medium">Tags</h2>
          <TagDropdown
            selectedTags={sidebarInfo.tagList}
            onTagChange={handleTagChange}
            onTagRemove={handleTagRemove}
          />
        </div>

        {/* Keyword Group */}
        <div>
          <h2 className="text-base font-medium">Keyword group</h2>
          <div className="mt-3">
            <KeywordGroupDropdown
              selectedKeywordGroups={sidebarInfo.keywordGroupList}
              onKeywordGroupChange={handleKeywordGroupChange}
              onKeywordGroupRemove={handleKeywordGroupRemove}
            />
          </div>
        </div>
      </div>

      {/* Dates and Tax */}
      <div className="flex flex-col gap-5 rounded border border-[#F1F1F1] bg-white p-5 shadow-sm">
        <div>
          <h2 className="text-base font-medium">Release date</h2>
          <div className="mt-3 flex flex-col gap-2">
            <input
              type="date"
              className="h-10 rounded border border-[#CECECE] px-3"
              value={formatDateForInput(sidebarInfo.releaseDate)}
              onChange={(e) => handleReleaseDateChange(e.target.value)}
            />
          </div>
        </div>
        <div>
          <h2 className="text-base font-medium">Sales date</h2>
          <div className="mt-3 flex flex-col gap-2">
            <input
              type="date"
              className="h-10 rounded border border-[#CECECE] px-3"
              value={formatDateForInput(sidebarInfo.salesStartAt)}
              onChange={(e) => handleSalesStartDateChange(e.target.value)}
              placeholder="판매 시작일"
            />
            <input
              type="date"
              className="h-10 rounded border border-[#CECECE] px-3"
              value={formatDateForInput(sidebarInfo.salesEndAt)}
              onChange={(e) => handleSalesEndDateChange(e.target.value)}
              placeholder="판매 종료일"
            />
          </div>
        </div>
        <div>
          <h5 className="text-base font-normal text-[#1D1D1D]">Tax settings</h5>
          <p className="mt-2 text-base font-normal text-[#1D1D1D]">
            Collect tax
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProductSidebar;
